import Vuex from 'vuex'
import { exhibitorStatus, getMeetingContact, getMessage, getQRCodeList, getDonationBooks} from '@/api/index'
import router from '@/router'
const getStore = (key) => {return localStorage.getItem(key)}
const setStore = (key, value) => {return localStorage.setItem(key, value)}
const useMsg = getStore('useMsg') ? JSON.parse(getStore('useMsg')) : ''
export default new Vuex.Store({
    state: {
        token: getStore('token'),
        useMsg: useMsg,
        corId: getStore('corId') || '',
        meetingId: getStore('meetingId'),
        statusData: {},
        meetingEntity: {}, // 会议实体（会议名/会期/地点，总览 banner 与完成页展示用）
        contactInfo: {},
        companyMsg: useMsg && getStore(useMsg.id) ? JSON.parse(getStore(useMsg.id)) : {},
        messageData: {}, // 添加messageData字段
        donationBooksData: [], // 添加捐赠书籍数据状态
        salesmanInfo: {
            name: '',
            phone: '',
            lastUpdatedAt: 0, // 添加时间戳，用于防止竞态条件
            manuallySet: false // 标记是否为手动设置
        }
    },
    mutations: {
        _setMeetingId (state, aug) {
            state.meetingId = aug
            setStore('meetingId', aug)
        },
        _setStatusData (state, aug) {
            state.statusData = aug
        },
        _setMeetingEntity (state, aug) {
            state.meetingEntity = aug || {}
        },
        _setStatusContactInfo (state, aug) {
            state.contactInfo = aug
        },
        _setCountryListList (state, aug) {
            state.countryList = aug
        },
        _setCorId (state, aug) {
            state.corId = aug
            setStore('corId', aug)
        },
        // 清除登录态（退出登录 / token 失效）—— 清 token / meetingId / corId 的 state 和 localStorage
        _clearAuth (state) {
            state.token = ''
            state.meetingId = ''
            state.corId = ''
            localStorage.removeItem('token')
            localStorage.removeItem('meetingId')
            localStorage.removeItem('corId')
        },
        setToken (state, aug) {
            console.log(aug, 'setTokensetTokensetToken')
            state.token = aug
            setStore('token', aug)
        },
        _setSalesmanInfo (state, aug) {
            state.salesmanInfo = {
                ...aug,
                lastUpdatedAt: Date.now(),
                manuallySet: aug.manuallySet || false
            }
        },
        _setMessageData (state, aug) {
            state.messageData = aug
        },
        _setDonationBooksData (state, aug) {
            state.donationBooksData = aug
        }
    },
    actions: {
        _actionStaus (ctx) {
           let hash = window.location.hash
            exhibitorStatus(ctx.state.meetingId).then(res => {
                ctx.commit('_setStatusData', res.data)
                if (hash !== '#/step9') {
                    if (res.data) {
                        const  {activityConfirm,confirm, productConfirm, dataConfirm, fileConfirm} = res.data
                        if (confirm == 0 || confirm == 2) {
                            router.push('/step1-submit')
                        }else if(confirm == -1 || confirm == null) {
                            router.push('/step1') 
                        } else if (confirm == 1 && (fileConfirm === null || fileConfirm === -1)) {
                            router.push('/step2')
                        } else if (confirm == 1 && (fileConfirm == 0  || fileConfirm == 4 || fileConfirm == 2)) {
                            router.push('/step3-submit')
                        }else if (confirm == 1 && fileConfirm == 1 && (dataConfirm === null || dataConfirm === -1)) {
                            router.push('/step4')
                        }else if (confirm == 1 && fileConfirm == 1 && (dataConfirm === 0 || dataConfirm === 2)) {
                            router.push('/step4-submit')
                        }else if (confirm == 1 && fileConfirm == 1 && dataConfirm === 1 && (productConfirm == null || productConfirm == -1 || productConfirm == 4)) {
                            router.push('/step5')
                          }else if (confirm == 1 && fileConfirm == 1 && dataConfirm === 1 && (activityConfirm == -2)) {
                            router.push('/step9')
                        }else if (confirm == 1 && fileConfirm == 1 && dataConfirm === 1 && (activityConfirm == null || activityConfirm == -1)) {
                            router.push('/step7')
                          }else if (confirm == 1 && fileConfirm == 1 && dataConfirm === 1 && (activityConfirm == 0 || activityConfirm == 2)) {
                            router.push('/step8')
                        }else if (confirm == 1 && fileConfirm == 1 && dataConfirm === 1 && productConfirm === 1) {
                            router.push('/step9')
                        }else if (activityConfirm === 1) {
                            router.push('/step9')
                        }
                    } else {
                        router.push('/step1')
                    }
                }
            })
        },
        _actionContactInfo (ctx) {
            getMeetingContact(ctx.state.meetingId).then(res => {
                ctx.commit('_setStatusContactInfo', res.data)
            })
        },
        async _actionSalesmanInfo (ctx) {
            try {
                // 如果业务员信息是在5秒内手动设置的，跳过重新获取，避免竞态条件
                const currentTime = Date.now()
                const lastUpdateTime = ctx.state.salesmanInfo.lastUpdatedAt || 0
                const isRecentlyManuallySet = ctx.state.salesmanInfo.manuallySet && (currentTime - lastUpdateTime < 5000)
                
                if (isRecentlyManuallySet) {
                    console.log('跳过业务员信息重新获取，避免竞态条件')
                    return
                }
                
                const { data: messageData } = await getMessage({
                    corporateId: ctx.state.corId,
                    meetingId: ctx.state.meetingId
                })
                
                // 将messageData存入store
                ctx.commit('_setMessageData', messageData || {})
                
                if (messageData && messageData.salesmanName) {
                    const { data: qrCodeData } = await getQRCodeList(ctx.state.meetingId)
                    if (qrCodeData && qrCodeData.length > 0) {
                        const salesmanInfo = qrCodeData.find(item => item.salesmanName === messageData.salesmanName)
                        if (salesmanInfo && salesmanInfo.phone) {
                            ctx.commit('_setSalesmanInfo', {
                                name: messageData.salesmanName,
                                phone: salesmanInfo.phone,
                                manuallySet: false
                            })
                            return
                        }
                    }
                    
                    ctx.commit('_setSalesmanInfo', {
                        name: messageData.salesmanName,
                        phone: '',
                        manuallySet: false
                    })
                } else {
                    ctx.commit('_setSalesmanInfo', {
                        name: '陈明宇',
                        phone: '13812345678',
                        manuallySet: false
                    })
                }
            } catch (error) {
                console.error('获取业务员信息失败', error)
                ctx.commit('_setSalesmanInfo', {
                    name: '陈明宇',
                    phone: '13812345678',
                    manuallySet: false
                })
            }
        },
        async _actionMessageData (ctx) {
            try {
                const { data: messageData } = await getMessage({
                    corporateId: ctx.state.corId,
                    meetingId: ctx.state.meetingId
                })
                ctx.commit('_setMessageData', messageData || {})
            } catch (error) {
                console.error('获取messageData失败', error)
                ctx.commit('_setMessageData', {})
            }
        },
        async _actionDonationBooksData (ctx) {
            try {
                if (ctx.state.statusData && ctx.state.statusData.exhibitorId) {
                    const response = await getDonationBooks(ctx.state.statusData.exhibitorId)
                    if (response.code === 1) {
                        ctx.commit('_setDonationBooksData', response.data || [])
                    } else {
                        ctx.commit('_setDonationBooksData', [])
                    }
                } else {
                    ctx.commit('_setDonationBooksData', [])
                }
            } catch (error) {
                console.error('获取捐赠书籍数据失败', error)
                ctx.commit('_setDonationBooksData', [])
            }
        }
    },
    getters: {

    }
})
